import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import startCase from 'lodash/startCase'
import isEqual from 'lodash/isEqual'

import './style.css.scss'

class SelectionField extends React.Component {

  handleSelectionChange = (option) => {
    !isEmpty(option) && this.props.input.onChange(option.value)
  }

  componentWillUnmount() {
    this.props.input.onChange('')
  }

  componentDidUpdate(prevProps) {
    if(!isEmpty(prevProps.items) && !isEqual(prevProps.items, this.props.items)) {
      const selectedValue = this.selectedValue()
      this.handleSelectionChange(selectedValue)
    }
  }

  getOptions = () => {
    return this.props.items.map(selectionItem => {
      return {
        value: selectionItem.id,
        label: selectionItem.label
      }
    })
  }

  selectedValue = () => {
    if (!this.props.input.value) {
      return null
    }

    return find(this.props.items, { id: this.props.input.value })
  }

  getPlaceholder = () => {
    const labelItem = find(this.props.items, {id: ''})
    return !!labelItem ? labelItem.label : `Select ${startCase(this.props.fieldName)}`
  }

  render() {
    return (
      <Select
        classNamePrefix="folloze-select"
        options={this.getOptions()}
        className={`input-dropdown-container ${this.props.className}`}
        onChange={this.handleSelectionChange}
        value={this.selectedValue()}
        tabIndex={this.props.tabIndex}
        placeholder={this.getPlaceholder()}/>
    )
  }
}

SelectionField.propTypes = {
  items: PropTypes.array.isRequired,
  tabIndex: PropTypes.number.isRequired,
  className: PropTypes.string,
  fieldName: PropTypes.string.isRequired
}

export default SelectionField